import React from 'react';
import { Shield, Users, BookOpen, MessageCircle, Newspaper, CreditCard, LogOut } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../../utils/cn';
import { useAuth } from '../../context/AuthContext';

const menuItems = [
  { path: '/admin', icon: Shield, label: 'Dashboard' },
  { path: '/admin/users', icon: Users, label: 'Usuários' },
  { path: '/admin/work-applications', icon: BookOpen, label: 'Candidaturas' },
  { path: '/admin/blog', icon: Newspaper, label: 'Blog' },
  { path: '/admin/notifications', icon: MessageCircle, label: 'Notificações' },
  { path: '/admin/payments', icon: CreditCard, label: 'Pagamentos' },
];

export const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <aside className="fixed left-0 top-0 h-full w-64 bg-indigo-950/90 border-r border-purple-500/20">
      <div className="p-6">
        <h2 className="text-xl font-bold text-purple-200 flex items-center">
          <Shield className="w-6 h-6 mr-2" />
          Admin Panel
        </h2>
      </div>

      <nav className="mt-6">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "flex items-center px-6 py-3 text-purple-200/70 hover:text-purple-200 hover:bg-white/5",
              location.pathname === item.path && "bg-white/10 text-purple-200"
            )}
          >
            <item.icon className="w-5 h-5 mr-3" />
            {item.label}
          </Link>
        ))}
      </nav>

      <button
        onClick={handleLogout}
        className="absolute bottom-6 left-6 right-6 flex items-center justify-center px-4 py-2 text-purple-200 hover:text-purple-100 bg-white/5 rounded-lg"
      >
        <LogOut className="w-5 h-5 mr-2" />
        Sair
      </button>
    </aside>
  );
};